<template>
  <el-dialog class="sureCheck"
             :visible.sync="sureVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="1300px"
             title="考勤确认">
    <el-alert :title="remark"
              type="warning"
              :closable="false">
    </el-alert>
    <div class="sureCheckTable">
      <el-scrollbar style="height:100%">
        <el-table border
                  :data="tableData"
                  highlight-current-row
                  height='400'>
          <el-table-column label="时间"
                           align="center"
                           property="sign_date">
          </el-table-column>
          <el-table-column label="星期"
                           property="week"
                           align="center">
          </el-table-column>
          <el-table-column label="上班时间"
                           property="sign_in"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.sign_in?scope.row.sign_in:'--'}}
            </template>
          </el-table-column>
          <el-table-column label="下班时间"
                           property="sign_out"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.sign_out?scope.row.sign_out:'--'}}
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.sign_in && scope.row.sign_out?'正常':'异常'}}
            </template>
          </el-table-column>
          <el-table-column label="上班确认"
                           align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.sign_in">
                {{scope.row.sign_in}}
              </div>
              <el-time-picker v-else
                              v-model="scope.row.resign_in"
                              arrow-control
                              size="mini"
                              format='HH:mm'
                              value-format='HH:mm'>
              </el-time-picker>

            </template>
          </el-table-column>
          <el-table-column label="下班确认"
                           align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.sign_out">
                {{scope.row.sign_out}}
              </div>
              <el-time-picker v-else
                              v-model="scope.row.resign_out"
                              arrow-control
                              size="mini"
                              value-format='HH:mm'
                              format='HH:mm'>
              </el-time-picker>
            </template>
          </el-table-column>
          <el-table-column label="备注"
                           align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.resign_remark"
                         size="mini"
                         placeholder="请选择状态">
                <el-option v-for="item in reasonList"
                           :key="item"
                           :label="item"
                           :value="item"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 type="primary"
                 @click="save">保存</el-button>
      <el-button size="small"
                 @click="sureVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
export default {
  data () {
    return {
      tableData: [],
      remark: "",
      reasonList: ""
    }
  },
  methods: {
    closeDialog () {
      this.tableData = []
      this.$emit('update:sureVisible', false)
    },
    attendanceTobeConfirmed () {
      oaApi.attendanceTobeConfirmed({}, 'get').then(res => {
        if (res) {
          this.tableData = res.data
          this.remark = res.ext.remark
          this.reasonList = res.ext.reason
        }
      })
    },
    save () {
      let data = []
      data = JSON.parse(JSON.stringify(this.tableData))
      for (let i in data) {
        // if (!data[i].sign_in && data[i].new_sign_in) {
        //   data[i].resign_in = data[i].new_sign_in
        // } else {
        //   data[i].resign_in = ''
        // }
        // if (!data[i].sign_out && data[i].new_sign_out) {
        //   data[i].resign_out = data[i].new_sign_out
        // } else {
        //   data[i].resign_out = ''
        // }
        delete data[i].new_sign_in
        delete data[i].new_sign_out
        delete data[i].sign_out
        delete data[i].sign_in
        delete data[i].week
      }
      oaApi.repairAttendance({ data: JSON.stringify(data) }, 'post').then(res => {
        if (res) {
          this.$message.success('确认成功');
          this.$store.dispatch("getUserInfo");
          this.closeDialog()
        }
      })
    }
  },
  watch: {
    sureVisible: {
      handler (newValue) {
        this.attendanceTobeConfirmed()
      },
      deep: true,
      immediate: false
    }
  },
  props: {
    sureVisible: 'Boolean'
  }
}
</script>
<style lang="scss">
.sureCheck {
    .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*height:600px;*/
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }
    .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
    }
    .el-dialog__body {
        padding: 10px 20px;
    }
    .sureCheckTable {
        margin-top: 10px;
        height: 100%;
        .redText {
            color: red;
        }
    }
}
</style>